export const LazyLinkApi = Symbol.for('LazyLinkApi');
